//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import { checkPermissionsApp, allowAccessibilityColors } from "@/assets/js/appFunc";
import store from "@/store";
import { builderMenuIcons } from "./menuIconsConst";
import { routeEditItemIds } from "./builderMenuConst";

const checkForChanges = () => document.querySelector(".app__saveBtn");

export default {
    name: "BuilderMenu",
    components: { AQDialog },
    props: ["value", "isExternal"],
    data() {
        return {
            builderIcons: builderMenuIcons,
            appBlockchainEnabled: false,
            hovered: null,
            menuHovered: null,
            menu: true,
            currentModuleHover: "",
            isOpen: false,
            mainItems: ["dashboard", "administration", "apps", "tasks"],
            sideBar: [
                {
                    name: "processes",
                    title: this.$t("mainPage.sideBar.processes"),
                    to: "/processes",
                    display: true,
                    permissionCode: "DI"
                },
                {
                    name: "smartContractContainer",
                    title: this.$t("mainPage.sideBar.smartcontract"),
                    to: "/smartContractList",
                    display: false,
                    permissionCode: "SC"
                },
                {
                    name: "userInterfaces",
                    title: this.$t("mainPage.sideBar.ui"),
                    to: "/userInterfaces",
                    display: true,
                    permissionCode: "IB"
                },
                {
                    name: "documents",
                    title: this.$t("mainPage.sideBar.documents"),
                    to: "/documentTemplates",
                    display: true,
                    permissionCode: "DB"
                },
                {
                    name: "apis",
                    firstApiPage: "consumed",
                    title: this.$t("mainPage.sideBar.api"),
                    to: "/integrations",
                    display: true,
                    permissionCode: "AP"
                },
                {
                    name: "dataModel",
                    title: this.$t("mainPage.sideBar.dataModel"),
                    to: "/dataModel",
                    display: true,
                    permissionCode: ["DM"]
                },
                {
                    name: "catalogs",
                    title: this.$t("dataModel.catalogs"),
                    to: "/catalogs",
                    display: true,
                    permissionCode: ["CS", "CD"]
                },
                {
                    name: "perspectiveBuilder",
                    title: this.$t("mainPage.sideBar.perspectiveBuilder"),
                    to: "/customDataViews",
                    display: true,
                    permissionCode: "PB"
                },
                {
                    name: "search",
                    title: this.$t("mainPage.sideBar.search"),
                    to: "/dataViews",
                    display: true,
                    permissionCode: "DP"
                },
                {
                    name: "reports",
                    title: this.$t("mainPage.sideBar.plv"),
                    to: "/analytics",
                    display: true,
                    permissionCode: { parent: "RP", child: ["TI", "ST"] },
                    menu: [{
                        name: "reports",
                        title: this.$t("liveView.leftSideBar.itemTasks"),
                        route: "/analytics/processLiveView",
                        to: "/analytics/processLiveView"
                    },
                    {
                        name: "statistics",
                        title: this.$t("liveView.leftSideBar.itemStatistics"),
                        route: "/analytics/processStatistics",
                        to: "/analytics/processStatistics"
                    }]
                },
                {
                    name: "applications",
                    title: this.$t("mainPage.sideBar.appSettings"),
                    to: "/settings",
                    display: true,
                    permissionCode: { parent: "AS", child: ["HL", "PE", "GR", "WS"] },
                    menu: [{
                        name: "highlights",
                        title: this.$t("applicationSettingsSidebar.settings"),
                        route: "/settings/general",
                        permissionCode: { parent: "AS", child: "HL" },
                        display: true
                    },
                    {
                        name: "appSchedule",
                        title: this.$t("applicationSettingsSidebar.workSchedule"),
                        route: "/settings/workSchedule",
                        permissionCode: { parent: "AS", child: "WS" },
                        display: true
                    },
                    {
                        name: "appSpecificGroups",
                        title: this.$t("applicationSettingsSidebar.applicationGroups"),
                        route: "/settings/appSpecificGroups",
                        permissionCode: { parent: "AS", child: "GR" },
                        display: true
                    },
                    {
                        name: "permissions",
                        title: this.$t("applicationSettingsSidebar.permissions"),
                        route: "/settings/permissions",
                        permissionCode: { parent: "AS", child: "PE" },
                        display: true
                    }]
                }
            ]
        };
    },
    computed: {
        ...mapGetters("main", ["activePage", "getInfoApp"]),
        ...mapGetters("apps", ["currentApp", "getCurrentAppUserPermissions"]),
        ...mapGetters("reports", ["getSelectedProcessReports", "getSelectedProcessStatistics"]),
        ...mapState("catalogs", ["items", "selectedCat"]),
        ...mapState("documentEditor", ["selectedDoc"]),
        ...mapState("components", ["activeInterface"]),
        ...mapState("perspectiveBuilder", ["selectedPerspective", "searchPerspectiveData", "draftSelectedPerspective"]),
        visibleSideBar() {
            return this.sideBar.filter(sidebar => {
                const hasPermissions = checkPermissionsApp(this.getCurrentAppUserPermissions, sidebar.permissionCode);
                if (sidebar.name === "applications") {
                    sidebar.menu = sidebar.menu.filter(el => el.display === true);
                }
                return sidebar.permissionCode === "SC" ? this.appBlockchainEnabled && hasPermissions : hasPermissions;
            });
        },
        checkActivePage() {
            return this.activePage && this.mainItems.indexOf(this.activePage) === -1 && this.currentApp.id;
        },
        getDialogDetails() {
            return {
                title: this.$t("documents.wrnTitle"),
                message: this.$t("userInterface.leavePageMsg")
            };
        }
    },
    watch: {
        currentApp: {
            handler(val) {
                if (val) {
                    this.sideBar.forEach(element => {
                        const elem = element;
                        if (val.canManage) {
                            if (elem.name === "smartContractList") {
                                elem.display = val.blockchainEnabled;
                            } else if (elem.name === "reports") {
                                elem.display = val.canView;
                            } else {
                                elem.display = true;
                            }
                        } else if (elem.name === "reports") {
                            elem.display = val.canView;
                        } else if (elem.name === "applications") {
                            elem.menu.forEach(it => {
                                it.display = !!checkPermissionsApp(this.getCurrentAppUserPermissions, it.permissionCode);
                            });
                        } else {
                            elem.display = false;
                        }
                    });
                    this.appBlockchainEnabled = val.blockchainEnabled;
                }
                this.$store.commit("diagrams/setConnectorsValidation", []);
                this.$store.commit("diagrams/setWarningsList", null);
            },
            immediate: true
        }
    },
    mounted() {
        this.setActiveIcon();
        const isMobile = localStorage.getItem("localIsSmallScreen");
        if (!isMobile) {
            store().dispatch("tasks/getUserDetails").then(data => {
                localStorage.setItem("accessibility", data.colorsAccessibility);
                const hasAccFeature = localStorage.getItem("accessibilityFeature");
                allowAccessibilityColors(data.colorsAccessibility && hasAccFeature === "true");
            });
        }
    },
    methods: {
        routeToModule(el, fromMainBtn, index) {
            this.hovered = index;
            const getRoute = (v) => (this.currentApp?.id ? `/applications/${this.currentApp.id}${v}` : v);
            if (fromMainBtn && el.name !== "applications" && el.name !== "reports") {
                const checkRoute = () => (el.name === "apis" && el.firstApiPage ? el.firstApiPage === this.$route.name : el.name === this.$route.name);
                if (checkRoute()) {
                    const routeParamType = routeEditItemIds[el.name];
                    if (routeParamType && this.$route.params[routeParamType]) {
                        this.$router.replace({ path: getRoute(el.to) });
                    }
                } else {
                    this.$router.push(getRoute(el.to)).catch(() => {
                        if ([this.selectedCat, this.selectedPerspective, this.searchPerspectiveData, this.draftSelectedPerspective,
                            this.selectedDoc].find(elem => Object.keys(elem).length) || this.activeInterface) {
                            if (checkForChanges()) {
                                this.isOpen = true;
                            } else {
                                this.$router.go(0);
                            }
                        }
                    });
                }
            } else if (!fromMainBtn) {
                if (el.name === this.$route.name) {
                    const routeParamType = routeEditItemIds[el.name];
                    if (routeParamType && this.$route.params[routeParamType]) {
                        this.$router.replace({ path: getRoute(el.to) });
                    }
                } else {
                    this.$router.push(getRoute(el.route)).catch(() => {
                        if ([this.selectedCat, this.selectedPerspective, this.draftSelectedPerspective,
                            this.searchPerspectiveData, this.getSelectedProcessReports.reports,
                            this.getSelectedProcessStatistics, this.selectedDoc].find(elem => Object.keys(elem).length) || this.activeInterface) {
                            if (checkForChanges()) {
                                this.isOpen = true;
                            } else {
                                this.$router.go(0);
                            }
                        }
                    });
                }
            }
        },
        mouseEnterBtn(item, index) {
            this.menuHovered = null;
            this.hovered = index;
            this.currentModuleHover = item;
            this.menu = true;
        },
        mouseLeaveBtn() {
            setTimeout(() => { this.hovered = null; }, 0);
        },
        mouseEnterMenu(index) {
            this.menuHovered = index;
        },
        mouseLeaveMenu() {
            setTimeout(() => { this.menuHovered = null; }, 0);
        },
        actionsList(item) {
            return item.menu || [{ title: item.title, route: item.to }];
        },
        setActiveIcon() {
            const paths = document.querySelectorAll(".active path");
            paths.forEach(el => {
                el.style.stroke = this.getInfoApp.colorCode;
            });
            const paths2 = document.querySelectorAll(".content-padding:not(.active) path");
            paths2.forEach(el => {
                el.style.stroke = "var(--q-color-default-nav-icon)";
            });
            const path3 = document.querySelectorAll(".content-padding:not(.active).hover-state path");
            path3.forEach(el => {
                el.style.stroke = "var(--q-color-bm-nav-hover)";
            });
        },
        btnClasses(pageName, idx) {
            const defs = ["row", "content-padding"];
            const childPriorityUI = {
                applications: ["highlights", "appSpecificGroups", "appSchedule", "permissions"]
            };
            if (idx === this.hovered || idx === this.menuHovered) {
                defs.push("hover-state");
                setTimeout(() => {
                    this.setActiveIcon();
                }, 0);
            }
            const checkIfAnalytics = () => (this.activePage === "analytics" && pageName === "reports");
            const checkIfDataViews = () => (this.activePage === "searchContainer" && pageName === "search");

            if (this.activePage === pageName || checkIfDataViews() || checkIfAnalytics() || (this.activePage === "process" && pageName === "processes")
                || (childPriorityUI[pageName] && childPriorityUI[pageName].indexOf(this.activePage) !== -1)) {
                defs.push("active");
                setTimeout(() => {
                    this.setActiveIcon();
                }, 0);
            }
            return defs;
        },
        okConfirm() {
            this.$store.commit("main/setInterfaceDirty", false);
            this.isOpen = false;
            const availableRoutes = ["perspectiveBuilder"];
            const { name: routeName } = this.$route || {};
            if (availableRoutes.includes(routeName)) {
                this.$root.$emit(`confirm_${routeName}_unsaved_changes`);
            }
            this.$router.go(0);
        },
        cancelConfirm() {
            this.isOpen = false;
        }
    }
};
